<template>
    <div class="flex flex-wrap items-center justify-center xs:space-y-0 text-center"
        :class="spanish || italian ? 'space-x-0 xs:space-x-3 lg:space-x-5' : 'gap-x-4 xs:gap-x-0 xs:space-x-4 lg:space-x-6 xl:space-x-7'"
    >
        <landing-nav-item @click="show('about-us')">
            {{ $t('nav.about') }}
        </landing-nav-item>

        <landing-nav-item @click="showHome('plans')">
            {{ $t('nav.plans') }}
        </landing-nav-item>

        <landing-nav-item @click="show('why-c2c')">
            {{ $t('nav.why') }}
        </landing-nav-item>

        <landing-nav-item @click="show('faq')">
            {{ $t('nav.faq') }}
        </landing-nav-item>

        <landing-nav-item>
            <a href="/how-to">
                {{ $t('nav.how-to') }}
            </a>
        </landing-nav-item>

        <landing-nav-item @click="show_contact_us = true">
            {{ $t('Contact Us') }}
        </landing-nav-item>

        <contact-us-modal
            :show="show_contact_us"
            @closed="contactUsClosed"
        >
            {{ $t('Contact Us') }}!
        </contact-us-modal>
    </div>
</template>

<script>
import { scrollIntoView } from 'scroll-js';
import LandingNavItem from './landing-nav-item.vue';
import ContactUsModal from './contact-us-modal.vue';

export default {
    components: {
        LandingNavItem,
        ContactUsModal,
    },

    props: {
        on_home: { default: true },
        home_route: { default: '/' },
    },

    data() {
        return {
            show_contact_us: false,
            spanish: window.locale == 'sp',
            italian: window.locale == 'it',
        }
    },

    methods: {
        scrollTo(id) {
            scrollIntoView(document.getElementById(id), document.body, {
                behavior: 'smooth',
            }).then(() => {
                // done scrolling document's body to show myElement
            });
        },
        show(section) {
            if (this.on_home || document.getElementById(section)) {
                this.scrollTo(section);
            } else {
                window.location = this.home_route + '#' + section;
            }
        },
        showHome(section) {
            if (this.on_home) {
                this.scrollTo(section);
            } else {
                window.location = this.home_route + '#' + section;
            }
        },
        contactUsClosed() {
            this.show_contact_us = false;
        },
    },
}
</script>
